import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { createItem } from '../services/items';

const URL_REGEX = /^https?:\/\//i;
const URL_EXTRACT_REGEX = /https?:\/\/\S+/i;

function extractUrl(params: URLSearchParams): string | null {
  const url = params.get('url');
  if (url && URL_REGEX.test(url)) return url;

  const text = params.get('text');
  if (text) {
    if (URL_REGEX.test(text.trim())) return text.trim();
    const match = text.match(URL_EXTRACT_REGEX);
    if (match) return match[0];
  }

  return null;
}

export default function ShareTargetPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const didRun = useRef(false);

  useEffect(() => {
    if (!user || didRun.current) return;
    didRun.current = true;

    const url = extractUrl(searchParams);
    const title = searchParams.get('title') || '';
    const text = searchParams.get('text') || '';

    if (url) {
      createItem(user.uid, {
        type: 'url',
        title: title || url,
        content: url,
      }).then(() => navigate('/', { replace: true }));
    } else if (title || text) {
      createItem(user.uid, {
        type: 'text',
        title: title || text.slice(0, 100),
        content: text || title,
      }).then(() => navigate('/', { replace: true }));
    } else {
      navigate('/', { replace: true });
    }
  }, [user, searchParams, navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 10, gap: 2 }}>
      <CircularProgress />
      <Typography color="text.secondary">Saving to Stash...</Typography>
    </Box>
  );
}
